import PropTypes from 'prop-types';
import Fontawesome from 'react-fontawesome';
import classNames from 'classnames';

import 'app/assets/stylesheets/academia_components/buttons.scss';

const SocialButton = ({ icon, children, className, textOnly, ...props }) => {
  const buttonProps = {
    ...props,
    className: classNames(
      'wp-social-button',
      {
        'text-only': textOnly,
      },
      className,
    ),
  };

  return (
    <button {...buttonProps}>
      <span className="wp-social-button-content">
        {!!icon && <Fontawesome name={icon} />}
        <span>{children}</span>
      </span>
    </button>
  );
};

// shared proptypes
const proptypes = {
  className: PropTypes.string,
  textOnly: PropTypes.bool,
};

export const FollowButton = ({
  userId,
  source,
  firstName,
  className = '',
  following = false,
  ...props
}) => {
  return (
    <span className="wp-social-button__container">
      <SocialButton
        style={following ? {} : { display: 'none' }}
        data-unfollow-user-id={userId}
        icon="check"
        {...props}
        className={'follow ' + className}
      >
        Following
      </SocialButton>
      <SocialButton
        style={following ? { display: 'none' } : {}}
        data-follow-user-id={userId}
        data-follow-user-source={source}
        data-follow-user-fname={firstName}
        icon="plus"
        {...props}
        className={'follow ' + className}
      >
        Follow
      </SocialButton>
    </span>
  );
};

FollowButton.propTypes = {
  ...proptypes,
  userId: PropTypes.number.isRequired,
  source: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
};

export const MessageButton = ({ userId, className = '', ...props }) => (
  <span className="wp-social-button__container">
    <SocialButton
      data-send-message
      data-recipient-id={userId}
      icon="comment"
      {...props}
      className={'message ' + className}
    >
      Message
    </SocialButton>
  </span>
);
MessageButton.propTypes = {
  ...proptypes,
  userId: PropTypes.number.isRequired,
};
